import React from 'react'
import styled from 'styled-components';
import bg from './gif.webp'
import mbg from './mbg4.png'
import road from './roadmap.svg'
import { Line, Circle } from 'rc-progress';
import { motion } from 'framer-motion';
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import point from './point.svg'

const Page = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    max-height: 100vh;
    width: 100%;
    background-image: url(${bg});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 0 0 5rem 0;
    @media only screen and (max-width: 768px) {
       background-position: center center;
        width: 100%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 2rem 0.5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

const Box = styled.div`
        height: auto;
        width: 49%;
        text-align: center;
        
    `;

const H = styled.h2`
    color: #FFF;
    font-weight: bolder;
    font-size: 2.5rem;
    margin: 75% 0 0 0;
    @media only screen and (max-width: 768px) {
        font-weight: bold;
        font-size: 1.8rem;
        margin: -1rem 0 0 0;
        text-align: center;
      }
`;

const Hper = styled.h2`
    color:  #FFF ;     // #f6c81d;   // rgba(246, 200, 29, 1)  
    font-weight: bold;
    font-size: 80px;
    margin-bottom: 1.5rem;
    @media only screen and (max-width: 1000px) {
        font-weight: 900;
        font-size: 50px;
        margin-bottom: 2rem;
      }
    @media only screen and (max-width: 768px) {
        font-weight: 900;
        font-size: 40px;
        margin-bottom: 0rem;
      }
`;

const Ht = styled.h2`
    color: #FFF;
    font-weight: 550;
    font-size: 2rem;
    @media only screen and (max-width: 768px) {
        font-weight: bolder;
        font-size: 1rem;
        text-align: center;
      }
`;

const T = styled.p`
    color: #FFF;
    font-weight: regular;
    font-size: 1.3rem;
    margin: 2rem 1rem;
    width: 25%;
    @media only screen and (max-width: 768px) {
        font-weight: 510;
        font-size: 1rem;
        margin: 1rem 0.5rem 0 0.5rem;
        width: auto;
    }
`;

const ProgresssBar = styled.div`
    width: 80%;
    margin: 5rem 1rem;
    @media only screen and (max-width: 1100px) {
        width: 95%;
        margin: 3rem 0 2rem 0;
    }
    @media only screen and (max-width: 1000px) {
        width: 97%;
        margin: 3rem 0 2rem 0;
        padding: 0 0 0 1rem;
    }
    @media only screen and (max-width: 768px) {
        width: 100%;
        margin: 2rem 0 2rem 0;
        padding: 0 0 0 1rem;
    }
`;

const Flex = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    text-align: center;
    @media only screen and (max-width: 768px) {
        display: none;
    }
`;

const Card = styled.div`
    background-color: #003070;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    width: auto;
    height: auto;
    border-radius: 1rem;
    display: grid;
    place-items: center;
    justify-content: space-between;
    padding: 80px 200px;
    z-index: 4;
    @media only screen and (max-width: 768px) {
        width: 95%;
        padding: 2rem 0.5rem 3rem 0.5rem;
        opacity: 0.9;
    }
`;

const Button = styled(motion.div)`
   cursor: pointer;
    border-radius: 1rem;
    height: 3rem ;
    width: 12rem;
    margin: 0.5rem 0 0 2rem;
    @media only screen and (max-width: 768px) {
        margin: 1rem 0 0 0;
        height: 2.7rem ;
        width: 80%;
    }
`;

const Input = styled.input`
    border: 2px solid #3368AE;
    background-color: transparent;
    border-radius: 1.5rem;
    color: #fbcf2c;
    font-size: 1.5rem;
    padding: 1rem;
    ::placeholder{
        color: #3368AE;
        font-size: 1.5rem;
    }
    &:focus {
        outline: none;
        border-color: #fbcf2c;
      }
    }
    @media only screen and (max-width: 768px) {
        font-size: 1rem;
        border-radius: 1rem;
    }
`;

const Hori = styled.div`
    display: flex;
    margin-top: 60px;
    
    @media only screen and (max-width: 768px) {
        display: grid;
        place-items: center;
        margin-top: 30px;
    }
`;

const PC = styled.div`
    display: block;
    width: 100%;
    height: auto;
    @media only screen and (max-width: 1025px) {
        width: 95%;
    }
    @media only screen and (max-width: 768px) {
        display: none;
    }
`;

const Mobile = styled.div`
    display: none;
    @media only screen and (max-width: 768px) {
        display: grid;
        place-items: center;
        height: auto;
        width: 100%;
    }
`;

const SGrid = styled.div`
    display: block
    @media only screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

const ImgContainer = styled.div`
    @media only screen and (max-width: 768px) {
        width: 100%;
        height: 22rem;
        margin: 1rem 0 -12% 0;
      }
`;

const Style = styled.div`
    display: none;
    @media only screen and (max-width: 768px) {
      display: flex;
      margin-bottom: 2rem; 
           width: 100%;
      justify-content: space-between;
      
    }
`;

const CustomLine = styled.div`
    width: 100%;
    height: 2px;
    background: #D2042D;
`;

const MStep = styled(Step)`
    display: block;
    @media only screen and (max-width: 768px) {
      display: none !important;
    }
`

const Page4 = () => {
    return (
        <Page id="roadmap">
            <SGrid>
                <Mobile>
                    <div><img src={road} alt="" style={{width:"100%"}} /></div>    
                </Mobile>
                <H>Roadmap</H>
            </SGrid>
            
            <ProgresssBar>
                <Flex style={{padding:"0 4rem"}}>
                    <Hper style={{color:"#FFF"}}>20%</Hper>
                    <Hper style={{color:"#FFF"}}>50%</Hper>
                    <Hper>75%</Hper>
                    <Hper>100%</Hper>
                </Flex>
                
                <Style style={{}}>
                    <Box>
                        <Hper>20%</Hper>
                        <T>All Social Giveaways will be announced! Follow us on Twitter and Discord for more details.</T>
                    </Box>
                    <Box>
                        <Hper>50%</Hper>
                        <T>Rim Merchandise Shop opens with Limited Edition Gear for NFT hodlers.</T>
                    </Box>
                </Style>
               
                <PC>
                    <ProgressBar
                        stepPositions={4}
                        height={3}
                        percent={75}
                        filledBackground="linear-gradient(to right, #ed213a, #93291e)"
                    >
                    <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                        style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                        width="40"
                        src={point}
                        />
                    )}
                    </Step>
                    <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                        style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                        width="40"
                        src={point}
                        />
                    )}
                    </Step>
                    <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                        style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                        width="40"
                        src={point}
                        />
                    )}
                    </Step>
                    <Step transition="scale">
                    {({ accomplished }) => (
                        <img
                        style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                        width="40"
                        src={point}
                        />
                    )}
                    </Step>
                     </ProgressBar>
                </PC>
                <Mobile>
                    <Line 
                        style={{marginTop:"1.5rem"}}
                        percent="50" strokeWidth="2"
                        strokeColor="#c6250a" trailColor="#60304c" 
                        gapPosition="2rem 2rem 1rem 1rem"
                       
                    /> 
                </Mobile>
                <Flex>
                    <T>All Social Giveaways will be announced! Follow us on Twitter and Discord for more details.</T>
                    <T>Rim Merchandise Shop opens with Limited Edition Gear for NFT hodlers.</T>
                    <T>Donation fund created to support Alzheimer’s Research and Stroke Prevention & Recovery.</T>
                    <T>Rim Metaverse prep begins!</T>
                </Flex>
            </ProgresssBar>

            
            <Style>
                <Box>
                    <Hper>75%</Hper>
                    <T>Donation fund created to support Alzheimer’s Research and Stroke Prevention & Recovery.</T>
                </Box>
                <Box>
                    <Hper>100%</Hper>
                    <T>Rim Metaverse prep begins!</T>
                    
                </Box>
            </Style>
            

            <SGrid>

                {/* <Mobile>
                    <ImgContainer>
                        <img src={BB} alt="" style={{width:"100%",height:"100%"}} />
                    </ImgContainer>
                </Mobile> */}

                {/* <Card>
                    <Ht>Get Alerts on Scholarship / Students Loan Essay Contests.</Ht>
                    <Hori>
                        <Input placeholder="Enter Email"></Input>
                        <Button 
                            // type="button"
                            whileHover={{ scale: 1.1}}
                            whileTap={{ scale: 0.7 }}
                        ><img src={submit} alt="" style={{width:"100%",height:"150%"}} /></Button>
                    </Hori>
                </Card> */}

            </SGrid>
        </Page>
    )
}

export default Page4
